function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 0 864)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M976 355c21 -30 32 -67 32 -103s-11 -73 -32 -103c6 -52 -12 -105 -48 -144c-15 -85 -90 -149 -177 -149h-175c-93 0 -201 32 -288 66v-66h-288v648h275l144 151c24 24 44 72 44 106c0 57 46 103 103 103h46c97 0 149 -93 149 -180c0 -43 -10 -91 -31 -129h67 c99 0 180 -81 180 -180c0 -7 0 -14 -1 -20zM216 -72v504h-144v-504h144zM897 169c25 21 39 51 39 83s-14 62 -39 83c5 13 8 27 8 40c0 60 -48 108 -108 108h-200c45 68 92 118 92 201c0 46 -23 108 -77 108c-25 0 -77 9 -77 -31c0 -53 -25 -116 -62 -154l-185 -193v-414 c80 -35 198 -72 288 -72h175c59 0 111 49 108 108v4c29 20 46 53 46 89c0 13 -3 27 -8 40z"
}));

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1008 1008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.655b9876.svg";
export { ForwardRef as ReactComponent };